import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { AccountBalanceWallet as WalletIcon } from '@mui/icons-material';
import { walletApi } from '../../services/expenseAccountsApi';
import { useExpenseBase } from '../../components/expense/voucherShared';
import WalletLedger, { WalletBalances } from '../../components/expense/WalletLedger';

// Employee wallet: one balance per currency plus the ledger (read-only).
const MyWallet = () => {
  const base = useExpenseBase();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [currency, setCurrency] = useState('');

  const load = useCallback(async () => {
    try {
      setData(await walletApi.me({ currency, page: page + 1, limit: rowsPerPage }).then((r) => r.data));
      setError(null);
    } catch (e) {
      setError(e);
    }
  }, [currency, page, rowsPerPage]);

  useEffect(() => { load(); }, [load]);

  return (
    <Box sx={{ bgcolor: 'background.default', p: 3 }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 600, fontSize: '30px', lineHeight: 1.5, letterSpacing: 1, display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <WalletIcon color="primary" />
        My Wallet
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Advances add to your wallet; settlements and reimbursements covered by the wallet reduce it. Each currency is kept separately.
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error.message}</Alert>}
      {!data && !error && <CircularProgress />}
      {data && (
        <>
          <WalletBalances balances={data.balances} />
          <WalletLedger
            data={data}
            page={page}
            rowsPerPage={rowsPerPage}
            onPage={setPage}
            onRowsPerPage={(n) => { setRowsPerPage(n); setPage(0); }}
            currency={currency}
            onCurrency={(c) => { setCurrency(c); setPage(0); }}
            voucherLink={(e) => `${base}/${e.voucher}`}
          />
        </>
      )}
    </Box>
  );
};

export default MyWallet;
